import React, { useEffect, useState } from "react";
import { deleteUser, getUserList } from "../../api/api";
import { toast } from "react-toastify";

const Deleteuser = ({ setUsers, users }) => {
  const [selectedUsers, setSelectedUsers] = useState({ id: "" });

  useEffect(() => {
    userlist();
  }, []);

  const userlist = async () => {
    try {
      const response = await getUserList();
      if (response) {
        setUsers(response.data);
      }
    } catch (e) {
      toast.error(e);
    }
  };

  const handleCheckboxChange = (id) => {
    setSelectedUsers({ id }); // simply overwrite with the new ID
  };

  const handleDelete = async () => {
    try {
      if (!selectedUsers.id) return;

      const response = await deleteUser(selectedUsers.id); // send single ID
      if (response) {
        toast.success("User deleted successfully");
        // Remove deleted user from list
        userlist();
      }
    } catch (e) {
      toast.error(e);
    }
    setSelectedUsers({ id: "" }); // reset selection
  };

  return (
    <div className="p-5 max-w-md ml-10">
      <h2 className="text-2xl font-bold mb-4 text-left">User List</h2>
      <ul className="list-none p-0">
        {users.map((user) => (
          <li
            key={user.id}
            className="flex items-center mb-3 border border-gray-300 rounded-lg px-3 py-2"
          >
            <input
              type="checkbox"
              onChange={() => handleCheckboxChange(user.id)}
              className="mr-3"
            />
            <span>
              {user.name} ({user.email})
            </span>
          </li>
        ))}
      </ul>
      <button
        onClick={handleDelete}
        disabled={users.length === 0}
        className="flex bg-red text-white px-4 py-2 rounded disabled:opacity-50 mt-10"
      >
        Delete Selected
      </button>
    </div>
  );
};

export default Deleteuser;
